import { Link, mergeStyles, TooltipHost, useTheme } from "@bps/fluent-ui";

import { Item } from "./SelectionList";

interface SelectionListItemsProps {
  onSelectedItemChange: (item: Item) => void;
  selectedItem?: Item;
  items?: Item[];
}

export const SelectionListItems = ({
  onSelectedItemChange,
  items,
  selectedItem
}: SelectionListItemsProps) => {
  const theme = useTheme();

  const linkStyles = mergeStyles({
    padding: theme.spacing.s1,
    "&:focus, &:hover, &:active, &:hover:active": {
      backgroundColor: theme.palette.neutralLighter,
      textDecoration: "none"
    },
    overflow: "hidden",
    textOverflow: "ellipsis"
  });

  const selectedStyles = mergeStyles(linkStyles, {
    "&, &:hover, &:focus, &:active, &:hover:active": {
      backgroundColor: theme.palette.neutralLight
    }
  });

  const handleSelectionChange = (next: Item) => () =>
    onSelectedItemChange(next);

  return (
    <>
      {items?.map(item => (
        <Link
          as="div"
          key={item.id}
          disabled={item?.disabled || false}
          onClick={handleSelectionChange(item)}
          className={item === selectedItem ? selectedStyles : linkStyles}
        >
          {item.showToolTip === true ? (
            <TooltipHost content={item.name}>{item.name}</TooltipHost>
          ) : (
            item.node || item.name
          )}
        </Link>
      ))}
    </>
  );
};
